import { Component, OnDestroy, OnInit, ViewChild, inject, signal } from '@angular/core';
import { Database, objectVal, ref, onValue, onChildChanged, onChildAdded, onChildRemoved, limitToLast, query, endAt } from '@angular/fire/database';
import { firstValueFrom, Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CalendarOptions, DateSelectArg, EventApi, EventClickArg } from '@fullcalendar/core';
import { FullCalendarComponent, FullCalendarModule } from '@fullcalendar/angular';
import { AgendaService } from './agenda.service';
import { UsuarioService } from '../usuario/usuario.service';
import { SharedService } from '../shared.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import momentPlugin from '@fullcalendar/moment'
import listPlugin from '@fullcalendar/list';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
import { LoadingService } from '../loading/loading.service';
import { MenuService } from '../menu/menu.service';
import { AlertaService } from '../alerta/alerta.service';
import moment from 'moment';
import 'moment/locale/es';

@Component({
  selector: 'app-agenda',
  standalone: true,
  providers: [provideNativeDateAdapter(), {provide: MAT_DATE_LOCALE, useValue: 'es-MX'}],
  imports: [FullCalendarModule, CommonModule, MatCardModule, MatGridListModule, MatIconModule, MatButtonModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, RouterLink],
  templateUrl: './agenda.component.html',
  styleUrl: './agenda.component.css'
})
export class AgendaComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private sharedService = inject(SharedService);
  private agendaService = inject(AgendaService);
  private alertaService = inject(AlertaService);
  private usuarioService = inject(UsuarioService);
  private loadingService = inject(LoadingService);
  private menuService = inject(MenuService);
  private subscriptions = new Subscription();
  
  idTemaFiltrado: string = 'ALL';
  tituloHoy = signal('');
  FechaHoy = new Date();

  @ViewChild('calendar') calendarComponent!: FullCalendarComponent;
  calendarOptions = signal<CalendarOptions>({
    locale: esLocale,
    titleFormat: (oDate: any) => {
      this.FechaHoy = oDate.end.marker;
      this.tituloHoy.set(oDate.date.day + ' de ' + moment(new Date().setMonth(oDate.date.month)).format('MMMM') + ' de ' + oDate.date.year);
      return this.tituloHoy();
    },
    plugins: [
      momentPlugin,
      interactionPlugin,
      dayGridPlugin,
      timeGridPlugin,
      listPlugin
    ],
    headerToolbar: {
      left: '',
      center: '',
      right: ''
    },
    initialView: 'listDay',
    weekends: true,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    eventClick: this.handleEventClick.bind(this),
    eventSources: [(info: any) => {
      this.loadingService.show();
      return this.cargaMes(info);
    }],
    eventSourceSuccess: (content, response) => {
      this.fnCountEventsContent()
      this.loadingService.hide();
    },
    defaultAllDay: true,
    eventOrder: "-tsLastUpdate",
    contentHeight: "auto",
    eventContent: this.renderEventContent.bind(this),
    noEventsContent: 'Cargando Entradas...'
  });
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  renderEventContent(eventInfo: any) {
    const divEl = document.createElement('div');
    divEl.classList.add('element-entrada-inserted');

    const spanEl = document.createElement('span');
    spanEl.innerText = eventInfo.event.title;

    const ahrefEl = document.createElement('a');
    ahrefEl.classList.add('ng-star-inserted');
    ahrefEl.onclick = function(event) {
      event.stopPropagation();
      window.open(`/entrada/${eventInfo.event.extendedProps.tema}/${eventInfo.event.id}`, '_blank');
    };

    const iconEl = document.createElement('mat-icon');
    iconEl.classList.add('mat-icon','notranslate','icon-open-new-window','material-icons','mat-ligature-font','mat-icon-no-color');
    iconEl.innerText = 'open_in_new';

    ahrefEl.appendChild(iconEl);
    divEl.appendChild(spanEl);
    divEl.appendChild(ahrefEl);

    // Devolvemos el objeto que FullCalendar espera
    return { domNodes: [divEl] };
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  today() {
    this.getCalApi().today();
  }
  back() {
    this.getCalApi().prev();
  }
  next() {
    this.getCalApi().next();
  }
  changeDatePicker(event: MatDatepickerInputEvent<Date>) {
    this.getCalApi().gotoDate(event.value!);
  }
  handleEventClick(info: any) {
    this.router.navigate([`/entrada/${info.event.extendedProps.tema}/${info.event.id}`]);
  }
  openWindow ($event: any, event: any) {
    $event.stopPropagation();
    window.open(`/entrada/${event.extendedProps.tema}/${event.id}`, '_blank');
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit(): void {
    this.subscriptions.add(
      this.agendaService.listenerAgenda$.subscribe((idTema:any) => {
        this.idTemaFiltrado = idTema;
        this.getCalApi()?.refetchEvents();
      })
    );
    this.listenerEntradas();
    this.menuService.changeTemaMenu(false);
  }
  ngOnDestroy(): void {
    this.menuService.changeTemaMenu(true);
    this.subscriptions.unsubscribe();
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getCalApi () {
    return this.calendarComponent.getApi();
  }
  formatEntradas (itemsEntradas: any) {
    return itemsEntradas.map((item: any) => {
      item.title = decodeURI(item.title);
      item.allDay = true;
      item.end = item.end.substr(0,11) + "24:00:00";
      return item
    });
  }
  async cargaMes (info: any) {
    //Obtenemos que mes quiere cargar
    const dateCalendar = (info == 'FORCE')?this.getCalApi().getDate():info.start;
    const mes_cargar = moment(dateCalendar).format('YYYY/MM');

    //Obtenemos las entradas guardadas
    const entradasGuardadas = this.sharedService.getEntradas();

    //Verificamos si no esta cargado
    if(this.sharedService.getFechas().includes(mes_cargar) == false || info == 'FORCE') {
      
      //Obtenemos las entradas nuevas
      const anio = mes_cargar.substring(0, 4);
      const mes = mes_cargar.substring(5, 7);
      const response: any = await firstValueFrom(this.agendaService.cargar(anio, mes));
      const entradas = this.formatEntradas(response.entradas);

      //Guardamos la fecha cargada
      this.sharedService.setFechas(mes_cargar);
      
      //Filtrar entradas duplicadas
      const ids = entradasGuardadas.map((item: any) => item.id);
      const entradasFiltradas = entradas.filter((item:any) => !ids.includes(item.id));
      
      //Agregamos las entradas
      const entradasActualizadas = entradasGuardadas.concat(entradasFiltradas);

      //Guardamos en share
      this.sharedService.setEntradas(entradasActualizadas);

      if(info == 'FORCE')
        return entradasFiltradas;
      
      if(this.idTemaFiltrado == 'ALL')
        return entradasActualizadas;
      
      return entradasActualizadas.filter((item:any) => item.tema == this.idTemaFiltrado);
    }

    if(this.idTemaFiltrado == 'ALL')
      return entradasGuardadas;
    
    return entradasGuardadas.filter((item:any) => item.tema == this.idTemaFiltrado);
  }

  async listenerEntradas () {
    const temas = await firstValueFrom(this.usuarioService.getTemasLectura());

    for (const tema of temas) {
      const temaRef = this.agendaService.getEntradasPorTema(tema);

      // 1. Obtener snapshot actual de entradas
      const snapshot = await firstValueFrom(objectVal(temaRef));
      const idsFirebase = snapshot ? Object.keys(snapshot) : [];

      // 2. Eliminar entradas locales que ya no están en Firebase
      const entradasLocales = this.sharedService.getEntradas();
      const entradasActualizadas = entradasLocales.filter((e:any) => e.tema !== tema || idsFirebase.includes(e.id));
      this.sharedService.setEntradas(entradasActualizadas);
      this.getCalApi()?.refetchEvents();

      onChildAdded(query(temaRef, limitToLast(1)), (data: any) => this.agregarEntrada(data.key, data.val()));
      onChildChanged(temaRef, (data) => this.cambiarEntrada(data.key, data.val()));
      onChildRemoved(temaRef, (data) => this.eliminarEntrada(data.key, data.val()));
    }
  }
  /*async listenerEntradas () {
    console.log("LISTENER ENTRADAS");
    const temas = await firstValueFrom(this.usuarioService.getTemasLectura());
    temas.map(tema => {
      let temaRef = this.agendaService.getEntradasPorTema(tema);

      onChildAdded(query(temaRef, limitToLast(1)), (data: any) => {
        this.agregarEntrada(data.key, data.val());
      });
      
      onChildChanged(temaRef, (data: any) => {
        this.cambiarEntrada(data.key, data.val());
      });
      
      onChildRemoved(temaRef, (data: any) => {
        this.eliminarEntrada(data.key, data.val());
      });

    });
  }*/

  agregarEntrada (key: any, oEntrada: any) {
    let entradasGuardadas: any[] = this.sharedService.getEntradas();
    //Buscamos si no la tenemos registrada
    if (entradasGuardadas.filter((item:any) => item.id === key).length === 0) {
      
      //Definimos el estilo de la clase
      let className = oEntrada.tema === "-KcOsYIkmr2FHgi4ubym" ? "corporativo"
                      : oEntrada.tema === "-KcOsYIoTX3wdcK4DMjF" ? "confidencial"
                        : oEntrada.tema === "-KcOsYIprL1TVCF2uyaO" ? "personal"
                          : "personal_confidencial";

      //Agregamos nuevo registro
      try {
        const end = oEntrada.end ? oEntrada.end.substr(0, 10) + "T24:00:00.00" : '';
        entradasGuardadas.push({
          id: key,
          title: oEntrada.asunto,
          tema: oEntrada.tema,
          tema_descripcion: oEntrada.tema_descripcion,
          tsLastUpdate: oEntrada.tsLastUpdate? oEntrada.tsLastUpdate.toString() : new Date().getTime().toString(),
          className: className,
          start: oEntrada.start,
          end,
          allDay: true,
        });
      } catch (error) {
        console.log(error);
        console.log(key, oEntrada);
      }

      this.sharedService.setEntradas(entradasGuardadas);
      this.getCalApi()?.refetchEvents();
    }
  }
  cambiarEntrada (key: any, oEntrada: any) {
    //Obtenemos las entradas guardadas
    let entradasGuardadas = this.sharedService.getEntradas();
    let encontrado: boolean = false;
    
    //Buscamos si la tenemos registrada
    entradasGuardadas = entradasGuardadas.map((item: any) => {

      //Actualizamos
      if (item.id === key) {
        let className = oEntrada.tema === "-KcOsYIkmr2FHgi4ubym" ? "corporativo"
          : oEntrada.tema === "-KcOsYIoTX3wdcK4DMjF" ? "confidencial"
            : oEntrada.tema === "-KcOsYIprL1TVCF2uyaO" ? "personal"
              : "personal_confidencial";

        item.title = oEntrada.asunto;
        item.tsLastUpdate = oEntrada.tsLastUpdate;
        item.start = oEntrada.start;
        item.end = oEntrada.end.substr(0, 10) + "T24:00:00.00";
        item.tema = oEntrada.tema;
        item.className = className;
        encontrado = true;
      }
      return item;
    });

    if (encontrado) {
      this.sharedService.setEntradas(entradasGuardadas);
      this.getCalApi()?.refetchEvents();
    }
  }
  async eliminarEntrada (key: any, oEntrada: any) {
   
    let entradasGuardadas = this.sharedService.getEntradas();

    //Buscamos si no la tenemos registrada
    entradasGuardadas = entradasGuardadas.filter((item:any) => item.id !== key);

    this.sharedService.setEntradas(entradasGuardadas);
    this.getCalApi()?.refetchEvents();

    const entrada = await this.agendaService.validateCambioTema(key, oEntrada.tema);
    if(entrada)
      this.agregarEntrada(key, entrada);
  }
  async cargaForzada () {
    this.loadingService.show();
    let entradasNuevas = await this.cargaMes('FORCE');

    if(entradasNuevas.length > 0) {
      this.alertaService.open(`Se han encontrado ${entradasNuevas.length} entradas nuevas.`,'');
      this.getCalApi().addEventSource(entradasNuevas);
    }

    this.loadingService.hide();
  }
  fnCountEventsContent() {
    setTimeout(() => {
      const calendarioEl = document.getElementsByClassName('calendario-content');
      const entradaEl = document.getElementsByClassName('element-entrada-inserted');
      if(calendarioEl.length != 0 && entradaEl.length == 0)
        this.getCalApi().setOption('noEventsContent', 'No se encontraron entradas');
    }, 2000);
  }
}
